import { LoadingIndicator } from '@/shared/ui'

const SUBSCRIBERS_FORMAT = new Intl.NumberFormat('ru-RU')

export type SubscribersCellProps = {
    linkId?: number
    subscribers?: number
}
export const SubscribersCell = ({
    linkId,
    subscribers = 0,
}: SubscribersCellProps) => {
    return (
        <>
            {!subscribers && !linkId ? (
                <div className="flex justify-end">
                    <LoadingIndicator
                        style={{
                            width: '20px',
                            height: '20px',
                            marginRight: '0.5em',
                        }}
                    />
                </div>
            ) : subscribers ? (
                SUBSCRIBERS_FORMAT.format(subscribers)
            ) : (
                <div className="long-dash">
                    <hr />
                </div>
            )}
        </>
    )
}
